import React from 'react';
import styles from '../../styles/AdminPage.module.css';

const AdminFilters = ({ searchTerm, setSearchTerm, filterStatus, setFilterStatus }) => {
  return (
    <div className={styles.filters}>
      <input
        type="text"
        placeholder="Search by name, email, job title, or company..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={styles.searchInput}
      />
      <div className={styles.filterButtons}>
        <button
          className={filterStatus === 'all' ? styles.filterActive : styles.filterButton}
          onClick={() => setFilterStatus('all')}
        >
          All
        </button>
        <button
          className={filterStatus === 'approved' ? styles.filterActive : styles.filterButton}
          onClick={() => setFilterStatus('approved')}
        >
          Approved
        </button>
        <button
          className={filterStatus === 'pending' ? styles.filterActive : styles.filterButton}
          onClick={() => setFilterStatus('pending')}
        >
          Pending
        </button>
      </div>
    </div>
  );
};

export default AdminFilters;
